import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import { sum } from 'lib/array/arrayUtils'

interface Props {
  variants?: Array<App.MerchandiseOfferVariant>
}

const MIN_INVENTORY = 5

function MerchandiseLowStockLabel({ variants }: Props) {
  const intl = useIntl()
  const totalInventory = useMemo(
    () => sum(variants?.map(variant => variant.inventory) ?? []),
    [variants],
  )

  const isLowInventory = useMemo(
    () => !!totalInventory && totalInventory <= MIN_INVENTORY,
    [totalInventory],
  )

  if (!isLowInventory) {
    return null
  }

  return <UrgencyLabel variant="critical2">
    {intl.formatMessage(
      {
        id: '8ybHgZSc6g',
        defaultMessage: '{count, plural, one {# left in stock} other {# left in stock}}',
        description: 'Label showing low stock quantity for merchandise',
      },
      { count: totalInventory },
    )}
  </UrgencyLabel>
}

export default MerchandiseLowStockLabel
